<div class="dialog-lab">
  <section class="hero">
    <div>
      <p class="eyebrow">Windowing groundwork</p>
      <h1>Dialog Lab</h1>
      <p class="lede">
        Launch the current dialogs from one place, compare shell styling, and identify which windows are ready for minimise-to-taskbar behaviour.
      </p>
    </div>

    <div class="hero-side">
      <div class="status">{{ status }}</div>
      <label class="search">
        <span>Filter dialogs</span>
        <input [(ngModel)]="search" placeholder="Search by name, group, or mode" />
      </label>
    </div>
  </section>

  <section class="summary">
    <div class="tile">
      <div class="value">{{ entries.length }}</div>
      <div class="label">Registered dialogs</div>
    </div>
    <div class="tile">
      <div class="value">{{ liveEntryCount }}</div>
      <div class="label">Live-data dialogs</div>
    </div>
    <div class="tile">
      <div class="value">{{ stubEntryCount }}</div>
      <div class="label">Stub-preview dialogs</div>
    </div>
    <div class="tile">
      <div class="value">{{ filteredEntries.length }}</div>
      <div class="label">Visible in filter</div>
    </div>
  </section>

  <section class="grid">
    <article class="card" *ngFor="let entry of filteredEntries">
      <div class="card-top">
        <span class="group">{{ entry.group }}</span>
        <span class="mode" [ngClass]="entry.mode.toLowerCase()">{{ entry.mode }}</span>
      </div>

      <h3>{{ entry.title }}</h3>
      <p>{{ entry.description }}</p>

      <button
        mat-flat-button
        color="primary"
        (click)="open(entry)"
        [disabled]="opening === entry.title">
        {{ opening === entry.title ? 'Opening...' : 'Open dialog' }}
      </button>
    </article>
  </section>
</div>
